export const reservationsRoutes = {
  list: "",
  reservationDetails: "assets/:aid/reservations/:rid",
} as const;
